import React from 'react';
import { BlockquoteTiptapItem } from "../tiptap/BlockquoteTiptapItem.js";
import { BoldTiptapItem } from "../tiptap/BoldTiptapItem.js";
import { DividerTiptapItem } from "../tiptap/DividerTiptapItem.js";
import { ItalicTiptapItem } from "../tiptap/ItalicTiptapItem.js";
import { LinkTiptapItem } from "../tiptap/LinkTiptapItem.js";
import { OrderedListTiptapItem } from "../tiptap/OrderedListTiptapItem.js";
import { StriketroughTiptapItem } from "../tiptap/StriketroughTiptapItem.js";
import { UnderlineTiptapItem } from "../tiptap/UnderlineTiptapItem.js";
import { UnorderedListTiptapItem } from "../tiptap/UnoderedListTiptapItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const getMarkdownConfig = editor => [{
  key: 'formatting',
  items: [/*#__PURE__*/_jsx(BoldTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(ItalicTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(UnderlineTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(StriketroughTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(BlockquoteTiptapItem, {
    editor: editor
  })]
}, {
  key: 'layout',
  items: [/*#__PURE__*/_jsx(OrderedListTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(UnorderedListTiptapItem, {
    editor: editor
  }), /*#__PURE__*/_jsx(DividerTiptapItem, {
    editor: editor
  })]
}, {
  key: 'add',
  items: [/*#__PURE__*/_jsx(LinkTiptapItem, {
    editor: editor
  })]
}];